import { render, staticRenderFns } from "./BatchNoChange.vue?vue&type=template&id=b6044b6c&scoped=true&"
import script from "./BatchNoChange.vue?vue&type=script&lang=js&"
export * from "./BatchNoChange.vue?vue&type=script&lang=js&"
import style0 from "./BatchNoChange.vue?vue&type=style&index=0&id=b6044b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6044b6c",
  null
  
)

export default component.exports